import { SetStateAction } from 'react';
import { SelectType } from '../components/DropdownSelect';
import Axios from '../utils/Axios';

export interface CurrentStoreContext {
  currentStore: SelectType;
  setCurrentStore: React.Dispatch<SetStateAction<SelectType>>;
}

export type StoreType = {
  address1: string;
  address2: string;
  city: string | null;
  description: string;
  description_extra: string;
  description_holiday: string;
  description_noti: string;
  id_order: number;
  is_hidden_on_map: number;
  is_mega_store: number;
  is_test_shop: number;
  lat: string;
  lng: string;
  noti_arrival_distance: number;
  noti_nearby_distance: number;
  order_time: number;
  parking_image: string;
  parking_pan: string;
  parking_tilt: string;
  parking_time: number;
  parking_zoom: number;
  pause: number;
  phone_number: string;
  pickup_address: string | null;
  pickup_type: number;
  postcode: any;
  province: any;
  review_count: number;
  status: number;
  store_code: string;
  store_id: number;
  store_name: string;
  store_type: number;
};

export type StoreDetailType = {
  seq: number;
  store_description: string;
  store_image: StoreImageType[];
};
export type StoreImageType = {
  store_media_id?: number;
  adver_media_id?: number;
  confirm_status?: number;
  confirm_detail?: number;
  url_path: string;
};

export type DeliveryType = {
  store_id?: number;
  limit_order_price: number;
  max_delivery_distance: string;
  base_delivery_price: number;
  base_delivery_distance: string;
  surcharge_delivery_distance: number;
  surcharge_delivery_price: number;
  is_self_delivery: number;
  delivery_call_type: number;
  delivery_estimated_time: number;
  delivery_prepare_time: number;
};
export type deliverySaleType = {
  more_order_price: number;
  more_delivery_price: number;
};

export type CouponType = {
  coupon_id: number;
  coupon_name: string;
  coupon_description: string | null;
  coupon_type: number;
  price?: number;
  percent?: number;
  max_discount?: number;
  start_date: string;
  end_date: string;
  is_count_limit: number;
  count_limit?: number;
  count_sent: number;
  count_used: number;
  requirement: number;
  created_at: string;
};

export type EditCouponType = {
  store_id: number;
  coupon_id?: number;
  coupon_name: string;
  coupon_type: number;
  price?: number;
  percent?: number;
  max_discount?: number;
  start_date: string | null;
  end_date: string | null;
  is_count_limit: number;
  count_limit?: number;
  requirement: number;
};

export type AdverHotelType = {
  store_id: number;
  store_name: string;
  is_ad: boolean;
  room_cnt: number;
  user_id: number;
  distance: number;
  ad_started_at?: string;
  confirm_type?: number;
  confirm_description?: string;
};
export type VoucherType = {
  address: string;
  address_en: string;
  benefit: string;
  benefit_en: string;
  comment: string;
  end_date: string;
  issue_date: string;
  lang: number;
  map_link: string;
  parent_store_id: number;
  phone_number: number;
  receiver_data: string;
  send_type: number;
  status: number;
  store_name: string;
  store_name_en: string;
  used_at?: string | null;
  user_token_id: number;
  voucher_history_id: number;
  voucher_id: number;
  hotel_name: string;
};

const StoreController = {
  // 필수 입력값 체크
  getEntryStatus: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/getEntryStatus`;
      const response: any = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[스토어매니저 입점 상태 확인 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 매장정보
  getStore: async (store_id: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${store_id}/getStore`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  editStore: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editStore';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 멀티매장
  setStore: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setStore';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[멀티매장 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 배달정보
  getDeliveryInfo: async (store_id: number) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/delivery/${store_id}/getDeliveryInfo`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setDeliveryInfo: async (
    storeId: number,
    deliveryManage: any,
    deliveryPrice: deliverySaleType[],
  ) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delivery/setDeliveryInfo';
      const oParams = {
        store_id: storeId,
        delivery_manage: deliveryManage,
        delivery_price: deliveryPrice,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 영업시간
  getBusinessTime: async (store_id: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${store_id}/getBusinessTime`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[영업시간 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setBusinessTime: async (store_id: number, work_time: any, break_time: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setBusinessTime';
      const oParams = {
        store_id: store_id,
        work_time: work_time,
        break_time: break_time,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[영업시간 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 사장님정보
  getMerchant: async (user_id: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${user_id}/getMerchant`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[사장님정보 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setMerchant: async (user_id: number, merchant: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setMerchant';
      const oParams = {
        user_id: user_id,
        merchant: merchant,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[사장님정보 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 매장 휴무 관리
  getHoliday: async (iStoreId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/' + iStoreId + '/getHoliday';
      const response: any = await Axios.get(sUrl);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장휴무 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setHoliday: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setHoliday';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장휴무 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 쿠폰 불러오기
  getCoupon: async (storeId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${storeId}/getCoupon`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[쿠폰 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 쿠폰 생성
  setCoupon: async (oParams: EditCouponType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/setCoupon`;

      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[쿠폰 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 쿠폰 삭제
  delCoupon: async (coupon_id: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/delCoupon`;
      const oParams = {
        coupon_id: coupon_id,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[쿠폰 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 광고관리 호텔 불러오기
  getHotelStore: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/getHotelStore`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[광고관리 호텔 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 입점 요청하기
  requestHotelStore: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/requestHotelStore`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[입점 요청하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 맛집 할인권
  getVoucher: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/store/getVoucher`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[직원확인 할인권 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  usesVoucher: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/store/useVoucher`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[할인권 사용 완료 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default StoreController;
